import React from 'react'
import { Box, Flex } from '@chakra-ui/react'

import RegisterSuscription from 'components/subscription/RegisterSuscription/registerSubscription'
import Form from 'providers/FormProvider'

interface SubscriptionDataProps {}

const SuscriptionData: React.FC<SubscriptionDataProps> = () => {
  const initValues = {
    nacionality: 'Argentina',
    document: '',
    documentForeign: '',
    documentType: 'cuil',
    name: '',
    lastName: '',
    email: '',
    areaCode: 'AR',
    phone: '',
    areaCodePhone: 'AR',
  }

  return (
    <Flex>
      <Box flex='1' id='right-side' px='6' py='0'>
        <Form initialValues={initValues}>
          <RegisterSuscription />
        </Form>
      </Box>
    </Flex>
  )
}

export default SuscriptionData
